import React from 'react';
import Projects from '../components/Projects';

const ProjectsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <Projects />
    </div>
  );
};

export default ProjectsPage;